import { render, staticRenderFns } from "./V3.vue?vue&type=template&id=f6820af6&scoped=true"
import script from "./V3.vue?vue&type=script&lang=js"
export * from "./V3.vue?vue&type=script&lang=js"
import style0 from "./V3.vue?vue&type=style&index=0&id=f6820af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6820af6",
  null
  
)

export default component.exports